'use client'

import { Spacer, Text } from '@vinted/web-ui'

import { SortByOption } from '@marketplace-web/domain/catalog-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'

import SelectableItemList, { SelectableListItem } from '../../../../components/SelectableItemList'

import FilterDropdown from '../FilterDropdown'

type SortItem = SelectableListItem<SortByOption, SortByOption>

type Props = {
  selected?: SortByOption
  onItemClick: (value: SortByOption) => void
  onDropdownOpen: () => void
}

const SortFilter = ({ selected = SortByOption.Relevance, onItemClick, onDropdownOpen }: Props) => {
  const translate = useTranslate('user.items.filters.sort')

  const handleItemClick = (item: SortItem) => {
    onItemClick(item.value)
  }

  const renderDropdown = () => {
    const items = Object.values(SortByOption).map(option => ({
      id: option,
      title: translate(`options.${option}`),
      value: option,
    }))

    return (
      <div className="u-ui-padding-vertical-x-small">
        <SelectableItemList<SortByOption, SortByOption>
          name="sort_by"
          items={items}
          selected={[selected]}
          onItemClick={handleItemClick}
        />
      </div>
    )
  }

  return (
    <div className="u-flexbox u-align-items-center">
      <Text as="h3" theme="amplified" type={Text.Type.Subtitle} text={translate('name')} />
      <Spacer orientation={Spacer.Orientation.Vertical} />
      <FilterDropdown
        title={translate(`options.${selected}`)}
        placement="bottom-end"
        closeOnClick
        onOpen={onDropdownOpen}
        testId="sort-filter-dropdown"
      >
        {renderDropdown()}
      </FilterDropdown>
    </div>
  )
}

export default SortFilter
